(function() {
    'use strict';

    const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
            else prevBtn.setAttribute('disabled', 'disabled')

            if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
            else nextBtn.setAttribute('disabled', 'disabled')
        }

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState)

        return () => {
            prevBtn.removeAttribute('disabled')
            nextBtn.removeAttribute('disabled')
        }
    }

    const addPrevNextBtnsClickHandlers = (
        emblaApi,
        prevBtn,
        nextBtn,
        onButtonClick
    ) => {
        const scrollPrev = () => {
            emblaApi.scrollPrev()
            if (onButtonClick) onButtonClick(emblaApi)
        }
        const scrollNext = () => {
            emblaApi.scrollNext()
            if (onButtonClick) onButtonClick(emblaApi)
        }
        prevBtn.addEventListener('click', scrollPrev, false)
        nextBtn.addEventListener('click', scrollNext, false)

        const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        )

        return () => {
            removeTogglePrevNextBtnsActive()
            prevBtn.removeEventListener('click', scrollPrev, false)
            nextBtn.removeEventListener('click', scrollNext, false)
        }
    }

    const addDotBtnsAndClickHandlers = (
        emblaApi,
        dotsNode,
        onButtonClick
    ) => {
        let dotNodes = []

        const addDotBtnsWithClickHandlers = () => {
            dotsNode.innerHTML = emblaApi
                .scrollSnapList()
                .map(() => '<button class="embla__dot" type="button"></button>')
                .join('')

            const scrollTo = (index) => {
                emblaApi.scrollTo(index)
                if (onButtonClick) onButtonClick(emblaApi)
            }

            dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
            dotNodes.forEach((dotNode, index) => {
                dotNode.addEventListener('click', () => scrollTo(index), false)
            })
        }

        const toggleDotBtnsActive = () => {
            const previous = emblaApi.previousScrollSnap()
            const selected = emblaApi.selectedScrollSnap()
            dotNodes[previous].classList.remove('embla__dot--selected')
            dotNodes[selected].classList.add('embla__dot--selected')
        }

        emblaApi
            .on('init', addDotBtnsWithClickHandlers)
            .on('reInit', addDotBtnsWithClickHandlers)
            .on('init', toggleDotBtnsActive)
            .on('reInit', toggleDotBtnsActive)
            .on('select', toggleDotBtnsActive)

        return () => {
            dotsNode.innerHTML = ''
        }
    }

    const addTabSwitchingHandlers = () => {
        const tabButtons = document.querySelectorAll('[data-embla-instance]');

        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const instanceId = this.dataset.emblaInstance;
                const targetIndex = parseInt(this.dataset.emblaIndex, 10);

                // Remove is-active from all buttons with the same instance
                const relatedButtons = document.querySelectorAll(`[data-embla-instance="${instanceId}"]`);
                relatedButtons.forEach(btn => btn.classList.remove('is-active'));

                // Add is-active to clicked button
                this.classList.add('is-active');

                // Hide all carousels with the same instance
                const carousels = document.querySelectorAll(`[data-embla="${instanceId}"]`);
                carousels.forEach((carousel, index) => {
                    if (index === targetIndex) {
                        carousel.classList.remove('d-none');
                    } else {
                        carousel.classList.add('d-none');
                    }
                });
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        const instances = {};
        const emblaNodes = document.querySelectorAll('.embla');

        for (const emblaNode of emblaNodes) {
            if (emblaNode) {
                const instance_id = emblaNode.dataset.embla;
                const component_options = JSON.parse(emblaNode.dataset.options);

                const OPTIONS = { align: 'start', loop: component_options.is_infinite, slidesToScroll: component_options.slides_to_scroll };
                const autoplay_options = {delay: component_options.autoplay_speed * 1000, stopOnMouseEnter: true};
                const plugins = [];

                if (component_options.is_autoplay){
                    plugins.push(EmblaCarouselAutoplay(autoplay_options));
                }

                const viewportNode = emblaNode.querySelector('.embla__viewport')
                const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
                const nextBtnNode = emblaNode.querySelector('.embla__button--next')
                const dotsNode = emblaNode.querySelector('.embla__dots')


                instances[instance_id] = EmblaCarousel(viewportNode, OPTIONS, plugins)

                const onNavButtonClick = (instances) => {
                    const autoplay = instances[instance_id].plugins().autoplay
                    if (!autoplay) return

                    const resetOrStop =
                        autoplay.options.stopOnInteraction === false
                            ? autoplay.reset
                            : autoplay.stop

                    resetOrStop()
                }

                if (prevBtnNode && nextBtnNode){
                    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
                        instances[instance_id],
                        prevBtnNode,
                        nextBtnNode,
                        onNavButtonClick
                    )

                    instances[instance_id].on('destroy', removePrevNextBtnsClickHandlers)
                }

                if (dotsNode){
                    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                        instances[instance_id],
                        dotsNode,
                        onNavButtonClick
                    )

                    instances[instance_id].on('destroy', removeDotBtnsAndClickHandlers)
                }
            }
        }

        // Initialize tab switching
        addTabSwitchingHandlers();
    });
})();
